import { combineReducers } from 'redux'
import uiFlags from './uiFlags'
import record from './record'

export default combineReducers({
  uiFlags,
  record,
})
